module.exports = __webpack_public_path__ + "static/media/96.3dcd4e26.jpg";